import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운영분석 화면 / E2E 플로우 맵 테이블 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId baselineDatetime managetypeId
   */
  getE2eFlowMapList(params) {
    return axios.post(`${baseUrl}/performance/analysis/e2e/get-agent-status-list.do`, params);
  },
  /**
   * 성능/운영분석 화면 / Agent별 현황 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params TODO 서비스단 변경 필요
   * serviceId, transactionId, rscKey, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   * @return {[json파일]}  [Agent별 현황 리스트]
   */
  getE2eAgentStatusList(params) {
    return axios.post(`${baseUrl}/performance/analysis/e2e/get-agent-status-list.do`, params);
  },
  getCurrentAgentStatusList(params) {
    return axios.post(`${baseUrl}/performance/analysis/e2e/get-current-agent-status.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/e2e/e2e-table-info.js